/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {unlockReward} from '../api'

export const useMutationUnlockReward = createReactQueryMutationHook('unlockReward', unlockReward)
